<template>
    <div class="panel panel-info" >
        <!-- Default panel contents -->
        <div class="panel-heading">
            <i class="fa fa-info-circle" aria-hidden="true"></i> CLIENTES NESTE PACPON
        </div>

        <div class="panel-body" >

            <div class="row">

                <div class="col-md-3" style="margin-top: 15px">
                    <button class="btn btn-block btn-success" :disabled="buscando" @click="buscar()">
                        <span class="fa fa-sync-alt"></span> ATUALIZAR
                    </button>
                </div>
                <div class="col-md-5">
                    <blockquote class="blockquote danger" v-if="buscando">
                        <span class="fa fa-sync-alt"></span> Atualizando
                    </blockquote>
                </div>
                <div class="col-md-4">
                    <blockquote class="blockquote-reverse text-right" :class="{'text-danger': portas <= ctos.length}">
                        TOTAL DE PORTAS: <b>{{ portas }}</b><br/>
                        TOTAL DE CLIENTES: <b>{{ ctos.length }}</b>
                    </blockquote>
                </div>

            </div>

            <table id="mytable" class="table table-bordred table-striped" v-if="ctos.length">

                <thead>
                    <tr>
                        <th>NOME</th>
                        <th style="text-align: center;width: 100px">PLANO</th>
                        <th style="text-align: center;width: 100px">STATUS</th>
                        <th style="text-align: center;width: 100px">AÇÕES</th>
                    </tr>
                </thead>

                <tbody>

                    <tr v-for="r in ctos" v-bind:key="r._id">
                        <td>{{ r.cliente.nome }}</td>
                        <td style="text-align: center; color: GREEN" >{{ r.megas }} MB</td>
                        <td style="text-align: center; color: GREEN" v-if="r.status">ONLINE</td>
                        <td style="text-align: center; color: RED" v-else>OFFLINE</td>

                        <td style="text-align: center">
                            <a :href="'#/contrato/add/' + r._id" class="btn btn-primary btn-xs">
                                ABRIR <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                            </a>
                        </td>
                    </tr>

                </tbody>

            </table>

            <div class="panel-body" v-else-if="buscando">
                <h3 style="padding-left: 20px">BUSCANDO CLIENTES NESTE PACPON</h3>
            </div>

            <div class="panel-body" v-else>
                <h3 style="padding-left: 20px">NENHUM CLIENTE NESTE PACPON</h3>
            </div>

        </div>

    </div>
</template>

<script>
import { Contratos } from "../../class/index";
export default {
    name: "ListClientesNoPacpon",
    props: {
        _id: {
            default: null
        },
        portas: {
            default: 1
        }
    },
    data() {
        return {
            buscando: false,
            interval: null,
            ctos: []
        };
    },
    async beforeMount() {
        this.buscar();
        this.interval = setInterval(() => this.buscar(), 60000);
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    methods: {
        async buscar() {
            if (!this.buscando) {
                this.buscando = true;
                this.ctos = await Contratos.byPacpon(this._id);
                this.buscando = false;
            }
        }
    }
};
</script>

<style scoped>
</style>
